import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Protected } from "./components/Protected";
import { DashboardLayout } from "./components/DashboardLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import PublicScorecard from "./pages/PublicScorecard";
import Pricing from "./pages/Pricing";
import Checkout from "./pages/Checkout";
import Invoice from "./pages/Invoice";
import CandidateDashboard from "./pages/candidate/CandidateDashboard";
import BookInterview from "./pages/candidate/BookInterview";
import InterviewRoom from "./pages/candidate/InterviewRoom";
import VoiceInterview from "./pages/candidate/VoiceInterview";
import Result from "./pages/candidate/Result";
import History from "./pages/candidate/History";
import ReadinessProfile from "./pages/candidate/ReadinessProfile";
import CandidateBilling from "./pages/candidate/Billing";
import CollegeDashboard from "./pages/college/CollegeDashboard";
import Students from "./pages/college/Students";
import Sponsor from "./pages/college/Sponsor";
import StudentProgression from "./pages/college/StudentProgression";
import CollegeReports from "./pages/college/CollegeReports";
import CollegeBilling from "./pages/college/Billing";
import ExpertDashboard from "./pages/expert/ExpertDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminConfig from "./pages/admin/AdminConfig";
import AdminBilling from "./pages/admin/AdminBilling";
import AgencyDashboard from "./pages/agency/AgencyDashboard";
import AgencyClients from "./pages/agency/AgencyClients";
import AgencyClientProfile from "./pages/agency/AgencyClientProfile";
import AgencyCandidates from "./pages/agency/AgencyCandidates";
import AgencyCandidateProfile from "./pages/agency/AgencyCandidateProfile";
import AgencyInterviews from "./pages/agency/AgencyInterviews";
import AgencyPipeline from "./pages/agency/AgencyPipeline";
import AgencyAnalytics from "./pages/agency/AgencyAnalytics";
import AgencyBilling from "./pages/agency/AgencyBilling";
import AgencySettings from "./pages/agency/AgencySettings";
import AgencyWorkQueue from "./pages/agency/AgencyWorkQueue";
import AdminAgencies from "./pages/admin/AdminAgencies";
import AgencyScorecard from "./pages/AgencyScorecard";

const withLayout = (el) => <Protected><DashboardLayout>{el}</DashboardLayout></Protected>;
const withLayoutRoles = (el, roles) => <Protected roles={roles}><DashboardLayout>{el}</DashboardLayout></Protected>;
const AGENCY_ROLES = ["agency_admin", "recruiter", "recruitment_manager"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/scorecard/:vid" element={<PublicScorecard />} />
            <Route path="/agency/scorecard/:vid" element={<AgencyScorecard />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
            <Route path="/invoice/:id" element={<Protected><Invoice /></Protected>} />

            <Route path="/candidate" element={withLayout(<CandidateDashboard />)} />
            <Route path="/candidate/book" element={withLayout(<BookInterview />)} />
            <Route path="/candidate/history" element={withLayout(<History />)} />
            <Route path="/candidate/readiness" element={withLayout(<ReadinessProfile />)} />
            <Route path="/candidate/billing" element={withLayout(<CandidateBilling />)} />
            <Route path="/candidate/result/:id" element={withLayout(<Result />)} />
            <Route path="/candidate/interview/:id" element={<Protected roles={["candidate"]}><InterviewRoom /></Protected>} />
            <Route path="/candidate/voice/:id" element={<Protected roles={["candidate"]}><VoiceInterview /></Protected>} />

            <Route path="/college" element={withLayout(<CollegeDashboard />)} />
            <Route path="/college/students" element={withLayout(<Students />)} />
            <Route path="/college/sponsor" element={withLayout(<Sponsor />)} />
            <Route path="/college/student/:id" element={withLayout(<StudentProgression />)} />
            <Route path="/college/reports" element={withLayout(<CollegeReports />)} />
            <Route path="/college/billing" element={withLayout(<CollegeBilling />)} />

            <Route path="/expert" element={withLayout(<ExpertDashboard />)} />
            <Route path="/admin" element={withLayout(<AdminDashboard />)} />
            <Route path="/admin/config" element={withLayout(<AdminConfig />)} />
            <Route path="/admin/billing" element={withLayout(<AdminBilling />)} />

            <Route path="/agency" element={withLayoutRoles(<AgencyDashboard />, AGENCY_ROLES)} />
            <Route path="/agency/clients" element={withLayoutRoles(<AgencyClients />, AGENCY_ROLES)} />
            <Route path="/agency/clients/:id" element={withLayoutRoles(<AgencyClientProfile />, AGENCY_ROLES)} />
            <Route path="/agency/candidates" element={withLayoutRoles(<AgencyCandidates />, AGENCY_ROLES)} />
            <Route path="/agency/candidates/:id" element={withLayoutRoles(<AgencyCandidateProfile />, AGENCY_ROLES)} />
            <Route path="/agency/interviews" element={withLayoutRoles(<AgencyInterviews />, AGENCY_ROLES)} />
            <Route path="/agency/pipeline" element={withLayoutRoles(<AgencyPipeline />, AGENCY_ROLES)} />
            <Route path="/agency/analytics" element={withLayoutRoles(<AgencyAnalytics />, AGENCY_ROLES)} />
            <Route path="/agency/work-queue" element={withLayoutRoles(<AgencyWorkQueue />, AGENCY_ROLES)} />
            <Route path="/agency/settings" element={withLayoutRoles(<AgencySettings />, ["agency_admin", "recruitment_manager"])} />
            <Route path="/agency/billing" element={withLayoutRoles(<AgencyBilling />, ["agency_admin", "recruitment_manager"])} />
            <Route path="/admin/agencies" element={withLayout(<AdminAgencies />)} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
